import { render, staticRenderFns } from "./base-toggle.vue?vue&type=template&id=3a5072f2&scoped=true"
import script from "./base-toggle.vue?vue&type=script&setup=true&lang=js"
export * from "./base-toggle.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-toggle.vue?vue&type=style&index=0&id=3a5072f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5072f2",
  null
  
)

export default component.exports